import { CheckCircle, ErrorOutlined } from "@mui/icons-material";
import { Button, Stack } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useCurrentUser } from "../../hooks/useCurrentUser";
import { useRemoteField } from "../../hooks/useRemoteField";
import { DataAction } from "../../types/action";
import { ESRFieldProps, ESRState } from "../../types/data";

// Additional info./question/confirmation required from project sponsor (yes/no)
// if yes then the following pops up: date field, text field that allows ~ 3 sentences.
export const ESRRequestInfoField = (props: ESRFieldProps) => {
	const dispatch = useDispatch();
	const [user, setUser] = useCurrentUser();
	const is_user_sponsor_in_esr = useSelector((state: ESRState) => state.is_user_sponsor_in_esr);
	const { question_id, locked } = props;
	const [deprecatedThreadId] = useRemoteField(
		`${question_id}.THREAD_ID`,
	);
	const [threadIdsStr] = useRemoteField(`${question_id}.THREAD_IDS`);
	const allThreadIds = [
		...(deprecatedThreadId ? [+deprecatedThreadId] : []),
		...(threadIdsStr ? JSON.parse(threadIdsStr) : []),
	];

	const threads = useSelector((state: ESRState) =>
		Object.values(state.threads),
	);

	const openUnresolvedThread = (threadId: number) => {
		dispatch<DataAction>({
			type: "UPDATE_DRAWER_STATE",
			update: {
				attachmentsOpen: false,
				threadsOpen: true,
				selectedThreadId: threadId,
				filters: {
					questionId: question_id,
				},
			},
		});
		dispatch<DataAction>({
			type: "REQUEST_INFO_FROM_SPONSOR",
		});
	};

	return (
		<Stack direction="column">
			{allThreadIds.map((threadId) => {
				const thread = threads.find((t) => t.id === threadId);
				const resolved =
					thread != null &&
					thread.messages.some((msg) => msg.sender_id !== user?.email) &&
					thread.unread_messages === 0;
				
				const isCreator = thread?.creator_id === user?.email;
				const isRecepient = thread?.["receiver_ids"]?.includes(user?.email ?? '');
				const isMessageSender = thread?.messages?.some(
					(msg) => msg.sender_id === user?.email
				);
				const isGroupAuthorized = thread?.groups?.some(
					(g) => user?.groups?.includes(g)
				);
				const isUserAdmin = user?.groups?.includes('Admin')
				let isUserGroupAllowedToSee = false
				if(thread?.question_id?.length ?? "".length > 0){
					user?.groups?.forEach((g) => {
						if (g.startsWith('RSU') || g.startsWith('CRU') || g.startsWith('NRU')) isUserGroupAllowedToSee = true;
					});
					// if(thread?.question_id?.startsWith('N')){
					// 	if(user?.groups?.includes('NRU')) isUserGroupAllowedToSee = true;
					// }
					// if(thread?.question_id?.startsWith('C')){
					// 	if(user?.groups?.includes('CRU')) isUserGroupAllowedToSee = true;
					// }
					// if(thread?.question_id?.startsWith('R')){
					// 	if(user?.groups?.includes('RSU')) isUserGroupAllowedToSee = true;
					// }
					// if(user?.groups?.includes('NRU') || user?.groups?.includes('CRU') || user?.groups?.includes('RSU')){
					// 	isUserGroupAllowedToSee = true;
					// }
				}
				const shouldDisable =
						!isCreator && !isMessageSender && !isGroupAuthorized && !isRecepient && !isUserAdmin && !isUserGroupAllowedToSee;

				return (
					<Button
						key={threadId}
						variant="outlined"
						color={resolved ? "success" : "error"}
						onClick={() => openUnresolvedThread(threadId)}
						startIcon={resolved ? <CheckCircle /> : <ErrorOutlined />}
						disabled={shouldDisable}
					>
						Thread #{threadId}
					</Button>
				);
			})}

			<Button
				variant="contained"
				onClick={() => openUnresolvedThread(-1)}
				disabled={locked > 0 && !is_user_sponsor_in_esr}
			>
				Create Thread
			</Button>
		</Stack>
	);
};
